import { asyncRoutes, constantRoutes } from '@/router'
import store from '@/store'
import Layout from '@/layout'

import { getIFramePath, getIFrameUrl } from '@/utils/iframe'
import { findNavTree } from '@/api/menu'


/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(permissionCodeList, route) {
  if (route.meta && route.meta.permission) {
    if ( route.meta.permission instanceof Array ) {
      return permissionCodeList.some(permission => route.meta.permission.includes(permission))
    } else {
      return permissionCodeList.indexOf(route.meta.permission) > -1
    }
  } else {
    return true
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, permissionCodeList) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(permissionCodeList, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, permissionCodeList)
      }
      res.push(tmp)
    }
  })

  return res
}

function addDynamicRoutesNew (list = []) {
  const arr = [];
  let obj = {};           
  list.forEach(item => {       
      const tmp = { ...item };
      if (tmp.children && tmp.children.length) {
        const chirlList = addDynamicRoutesNew(tmp.children)
        obj = {
          path: '/' + item.perms,
          component: Layout,
          //  name: item.name,
          alwaysShow: true,
          meta: {
            icon: item.icon,
            index: item.id,
            permission: item.perms,
            title: item.name
          }
        }
        obj.children = chirlList;
        arr.push(obj)
      }
      else {
        obj = {
          path: item.url || '/',
          component: null,
          //  name: item.name,
          meta: {
            icon: item.icon,
            index: item.id,
            permission: item.perms,
            title: item.name,
            type: item.type,
          },
        }
        let path = getIFramePath(item.url)
        if (path) {
          // 如果是嵌套页面, 通过iframe展示
          obj['path'] = item.url
          obj['component'] = resolve => require([`@/views/IFrame/IFrame`], resolve)
          obj.meta.extraTitle = item.name
          // 存储嵌套页面路由路径和访问URL
          // let url = getIFrameUrl(item.url)
          // let iFrameUrl = { 'path': path, 'url': url }
          // store.commit('addIFrameUrl', iFrameUrl)
        } else {
          try {
            // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
            // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
            item.url = item.url.replace(/^\//, '')
            let array = item.url.split('/')
            let url = ''
            for(let i=0; i<array.length; i++) {
              url += array[i].substring(0,1).toUpperCase() + array[i].substring(1) + '/'
            }
            url = url.substring(0, url.length - 1)
            obj['name'] = url.split('/').pop()
            obj['component'] = resolve => require([`@/views/${url}`], resolve)
          } catch (e) {
            console.log(e)
          }
        }
        arr.push(obj)
      }
  })
  return arr;
}

/**
* 添加动态(菜单)路由
* @param {*} menuList 菜单列表
* @param {*} routes 递归创建的动态(菜单)路由
*/
// function addDynamicRoutes (menuList = [], routes = []) {
//   var temp = []
//   for (var i = 0; i < menuList.length; i++) {
//     if (menuList[i].children && menuList[i].children.length >= 1) {
//       temp = temp.concat(menuList[i].children)
//     } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
//        menuList[i].url = menuList[i].url.replace(/^\//, '')
//        // 创建路由配置
//         var route = {
//           path: '/' + menuList[i].url,
//           component: null,
//           //  name: menuList[i].name,
//           meta: {
//             icon: menuList[i].icon,
//             index: menuList[i].id,
//             permission: menuList[i].perms,
//           }
//         }
//       //  let path = getIFramePath(menuList[i].url)
//       //  if (path) {
//       //    // 如果是嵌套页面, 通过iframe展示
//       //    route['path'] = path
//       //    route['component'] = resolve => require([`@/views/IFrame/IFrame`], resolve)
//       //    // 存储嵌套页面路由路径和访问URL
//       //    let url = getIFrameUrl(menuList[i].url)
//       //    let iFrameUrl = {'path':path, 'url':url}
//       //    store.commit('addIFrameUrl', iFrameUrl)
//       //  } else {
//         try {
//           // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
//           // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
//           let array = menuList[i].url.split('/')
//           let url = ''
//           for(let i=0; i<array.length; i++) {
//             url += array[i].substring(0,1).toUpperCase() + array[i].substring(1) + '/'
//           }
//           url = url.substring(0, url.length - 1)
//           route['name'] = url.split('/').pop()
//           route['component'] = resolve => require([`@/views/${url}`], resolve)
//         } catch (e) {}
//       // }
//       routes.push(route)
//     }
//   }
//   if (temp.length >= 1) {
//     addDynamicRoutes(temp, routes)
//   } else {
//     console.log('动态路由加载...')
//     console.log(routes)
//     console.log('动态路由加载完成.')
//   }
//   return routes
//  }

 /**
 * 处理路由到本地直接指定页面组件的情况
 * 比如'代码生成'是要求直接绑定到'Generator'页面组件
 */
// function handleStaticComponent(router, dynamicRoutes) {
//   for(let j=0;j<dynamicRoutes.length; j++) {
//     if(dynamicRoutes[j].name == '代码生成') {
//       dynamicRoutes[j].component = Generator
//       break
//     }
//   }
//   router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
// }

const state = {
  routes: [],
  addRoutes: [],
  navTree: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRoutes.concat(routes)
  },
  SET_NAVTREE: (state, navTree) => {
    state.navTree = navTree
  }
}

const actions = {
  generateRoutes({ commit }, {roleNames, permissionCodeList}) {
    return new Promise(resolve => {

      findNavTree().then(res => {
        // console.log(res.data)
        var navTree = res.data
        commit('SET_NAVTREE', navTree)
        // 菜单数据组装成路由 asyncRoutes
        // let dynamicRoutes = addDynamicRoutes(navTree)
        // console.log(dynamicRoutes)
        let accessedRoutes = addDynamicRoutesNew(navTree)
        // console.log(accessedRoutes)
        accessedRoutes = filterAsyncRoutes(accessedRoutes, permissionCodeList)
        // console.log(accessedRoutes)
        accessedRoutes = accessedRoutes.concat({
          path: '*',
          redirect: '/403',
        })
        commit('SET_ROUTES', accessedRoutes)
        resolve(accessedRoutes)
      })

      // let accessedRoutes = []
      // // if (roleName === 'Admin') {
      // //   accessedRoutes = asyncRoutes || []
      // // } else {
      //   accessedRoutes = filterAsyncRoutes(asyncRoutes, permissionCodeList)
      //   console.log(accessedRoutes)
      // // }
      // commit('SET_ROUTES', accessedRoutes)
      // resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
